import { Query } from "@tanstack/react-query";
import { PuckValue } from "~point/point.model";

export const pageSizes = [10, 20, 50];
export const defaultPageSize = 10;
export const invalidCharacters = /^[^<>&"'\\/:*?|]*$/;
export const commonDebounceDelay = 400;
// Maximum number of alarms shown in the bell icon
export const alarmBellLimit = 10;
// Maximum number of disconnected devices shown in the navbar notification icon
export const deviceNoticationLimit = 10;
// Maximum number of devices shown in the popover list when the user clicks the disconnected devices navbar icon
export const deviceNotificationListLimit = 20;
// TEMPORARY - set the maximum amount of alarms fetched in one query
export const alarmFetchLimit = 500;

type RefetchIntervalFn = {
  fn(query: Pick<Query, "state">): number | false;
}["fn"];

export type QueryOptions = {
  customQueryKey?: string;
  enabled?: boolean;
  refetchInterval?: number | RefetchIntervalFn;
  refetchIntervalInBackground?: boolean;
  staleTime?: number;
};

export const appEnvironments = ["localhost", "dev", "prod"] as const;

export type AppEnv = (typeof appEnvironments)[number];

const subdomain = window.location.hostname.split(".")[0] || "";
const subdomainParts = subdomain.split("-");
const envSuffix = subdomainParts[0] as AppEnv;
export const currentEnv = appEnvironments.includes(envSuffix)
  ? envSuffix
  : "prod";

export const isEqual = (
  prevEvent: PuckValue,
  currEvent: PuckValue,
): boolean => {
  return (
    // For performance comparing only updatable keys
    prevEvent.value === currEvent.value &&
    prevEvent.decimals === currEvent.decimals &&
    prevEvent.unit === currEvent.unit &&
    prevEvent.lockState === currEvent.lockState &&
    prevEvent.alarmState === currEvent.alarmState &&
    prevEvent.errorState === currEvent.errorState &&
    prevEvent.label === currEvent.label
  );
};

export const ALLOWED_GRAPHICS_EXTENSIONS = [
  "gif",
  "png",
  "htm",
  "jpg",
  "txt",
  "csv",
  "css",
  "svg",
  "log",
  "pdf",
  "jpeg",
  "html",
  "js",
];
